import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import AppRouter from './router/AppRouter'
import './index.css'

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
      <AppRouter />
    </Provider>,
)
